import {
  BlueprintProvider,
  BoxProps,
  Container,
  ContainerProps,
  LoadingOverlay,
} from '@hover/blueprint';
import React, { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Navbar from './navbar';
import SEO, { MetadataItem } from './Seo';
import Analytics from './Analytics';
import {
  PARTNER_BEACON_DESKTOP_LINKS,
  PARTNER_BEACON_MOBILE_LINKS,
} from '../../constants';

interface Props extends ContainerProps {
  isNavbarWhite?: boolean;
  navbarBackgroundColor?: BoxProps['color'];
  title?: string;
  description?: string;
  additionalMetadata?: MetadataItem[];
  noIndex?: boolean;
  titleColor?: string;
  showSafariDownloadAppBanner?: boolean;
  loading?: boolean;
}
const PartnerLayout: FC<Props> = ({
  children,
  isNavbarWhite,
  navbarBackgroundColor,
  title = '',
  description = '',
  noIndex = false,
  additionalMetadata = [],
  titleColor,
  showSafariDownloadAppBanner,
  loading = false,
  ...restProps
}) => (
  <BlueprintProvider resetCSS includeFonts newTypography>
    <Analytics />
    {showSafariDownloadAppBanner && (
      <meta name="apple-itunes-app" content="app-id=942568673" />
    )}
    <SEO
      title={title}
      description={description}
      disableTitleTemplate
      additionalMetadata={additionalMetadata}
      noIndex={noIndex}
    />
    {loading ? (
      <LoadingOverlay isLoading={loading} />
    ) : (
      <>
        <Navbar
          linksDesktop={PARTNER_BEACON_DESKTOP_LINKS}
          linksMobile={PARTNER_BEACON_MOBILE_LINKS}
          isNavbarWhite={!!isNavbarWhite}
          navbarBackgroundColor={navbarBackgroundColor}
          titleColor={titleColor}
          logo={
            <StaticImage
              placeholder="blurred"
              src="../../assets/images/beacon_logo.png"
              alt="Beacon logo"
              height={20}
            />
          }
        />

        <Container
          centerContent
          maxW="100%"
          px={0}
          pt={{ base: 900, desktop: 1000 }}
          overflowX="hidden"
          {...restProps}
        >
          {children}
        </Container>
      </>
    )}
  </BlueprintProvider>
);

PartnerLayout.defaultProps = {
  showSafariDownloadAppBanner: false,
  navbarBackgroundColor: 'neutral.0',
  isNavbarWhite: true,
  titleColor: undefined,
};

export default PartnerLayout;
